export interface AuthUser {
  username: string
  email: string
  name: string
  isAdmin: boolean
  userId: string
}

export enum AuthType {
  Invalid = "Invalid",
  Authenticated = "Authenticated",
}

export interface AuthState {
  type: AuthType
  user?: AuthUser
  userExpires?: Date
}

export interface AuthenticatedParams {
  user: AuthUser
  csrfToken: string | null
  userExpires: Date
  storeCredentials: boolean
}
